<template>
    <div class="layout-common">
        <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>
        <div class="register-result">
            <img style="width:100px"
                src="https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202207/bc618504717e4b29b13721ee9b77a4da.png"
                class="icon">
            <div class="txt1">Registration successful</div>
            <div class="txt2">Congratulations，{{ company }} Company，you have successfully registered for the 26th
                National
                Hospital Construction Conference and International Hospital<br />
                Construction, Equipment and Management Exhibition If in doubt, you can call +86 18610936857 or
                aliceshang@chccchina.com</div>

            <div class="f-tac  btn">
                <Button type="primary" size="large" @click="linkTo">Return to the official website</Button>
            </div>
            <!-- <img src="@assets/img/qrCode.png">
      <div class="txt3">WeChat</div> -->
        </div>
    </div>
</template>

<script>
import gSwiper from "@components/gSwiper/gSwiper2.vue";
export default {
    name: 'register-result',
    components: {
        gSwiper,
    },
    data() {
        return {
            company: '',
            exname: '',
            //   arr: [{ id: 1, path: require('../../../../assets/img/banner.png') }],
            arr: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202306/085ad3e0c123436d8f3a1f428f0b2527.jpg' }],

        };
    },
    watch: {},
    computed: {},
    methods: {
        linkTo() {
            window.location.href = 'http://www.chccchina.com/en';
        },
        IsPC() {
            var userAgentInfo = navigator.userAgent;
            var Agents = ["Android", "iPhone",
                "SymbianOS", "Windows Phone",
                "iPad", "iPod"];
            var flag = true;
            for (var v = 0; v < Agents.length; v++) {
                if (userAgentInfo.indexOf(Agents[v]) > 0) {
                    flag = false;
                    break;
                }
            }
            return flag;
        }
    },
    created() {
        if (this.IsPC()) {
            this.arr = [{ id: 1, path: require('../../../../assets/img/banner.png') }]
        } else {
            this.arr = [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202306/085ad3e0c123436d8f3a1f428f0b2527.jpg' }]

        }

    },
    mounted() {
        const query = this.$route.query;
        this.company = query.company;
        this.exname = query.exname;
        console.log('query', query);
    },

}

</script>

<style lang="scss" scoped>
.layout-common {

    margin: 0 auto;
}

.register-result {
    width: 100%;
    text-align: center;

    .icon {
        display: block;
        margin: 80px auto 25px;
    }

    .txt1 {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        margin-bottom: 20px;
    }

    .txt2 {
        font-size: 16px;
        color: #333;
        margin-bottom: 25px;
        line-height: 1.8;
        padding: 20px;
    }

    .txt3 {
        font-size: 14px;
        color: #666;
        margin-bottom: 120px;
    }
}

.btn {
    button {
        height: 48px;
        padding: 0 50px;
        background-color: #fff;
        font-size: 18px;
        border-radius: 5px;
        border: solid 1px #e5e5e5;
        margin-bottom: 80px;
        color: #333;
    }
}
</style>
